import { React, useRef, useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import TokenService from '../../services/TokenService'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Link from '@mui/material/Link';
import StoreIcon from '@mui/icons-material/Store';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

const CustomerOrRecyclerConfirmation = (props) => {

    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>

            <div style={{ fontSize:' calc(12pt + .5vw)', marginTop:'15px', marginBottom:'15px'} }>
                Do you want to be a Customer or a Recycler?
            </div>

            <div style={{ display: 'flex', marginTop: '10px' }}>
                <StoreIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} />
                <div style={{textAlign:'left', marginLeft:'5px'} }>If you would like to become a customer, then you do <b>not need to sign up here.</b></div>
            </div>

            
                <div style={{ textAlign: 'left' }}>
                    Select "Pickup my Cans" and enter your zip code to request a pickup.
                </div>

            <div style={{ textAlign: 'left' }}>

                <Button
                    component={Link}
                    href='/Pickup'
                    sx={{ background: 'var(--sipzee-yellow)', width:'260px' }}
            >Pickup my cans</Button>
            </div>


            <div style={{ display: 'flex', marginTop: '25px', justifyContent:'flex-end' }}>
                <div>
                    If you would like to sign-up to be a Recycler and pickup cans to make some cash, then you are in the right place.
                </div>
                <DirectionsCarIcon sx={{ color: 'var(--sipzee-green)', fontSize: 50 }} />
            </div>


            <div style={{display:'flex', justifyContent:'flex-end', marginTop:'15px'} }>


              
                <Button style={{ alignSelf: 'center', marginLeft:'2px' }} color="sipzeeGreen" variant="contained" onClick={(e) => props.Next()} >Become a Recycler</Button>
            
            </div>
        </div>
    )

}

export default CustomerOrRecyclerConfirmation;